import { useFormContext } from 'react-hook-form';

import { useCheckReference } from '@/components/modules/Application/components/References/_shared/hooks/useCheckReference';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

interface OrderReferenceFormProps extends FormGridOptions {}

export const OrderReferenceForm = ({ fieldVariant, fullWidth = false }: OrderReferenceFormProps) => {
  const {
    actions: { updateApplicationContext },
  } = useApplicationContext();
  const { watch } = useFormContext();

  const { referenceAvailable } = useCheckReference({ referenceName: 'orderReference1' });

  const orderReference2Watcher = watch('orderReference2');

  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
      <TextFormField
        name={'orderReference1'}
        label={'ORDER_REFERENCE_1'}
        fieldVariant={FieldVariant.form}
        labelIcon={'info'}
        labelIconPosition="end"
        tooltipTitle={<Text tId={'ORDER_REFERENCE_1_TOOLTIP'} />}
        InputProps={{
          endAdornment: referenceAvailable,
        }}
      />
      <TextFormField
        name={'orderReference2'}
        onBlurCapture={() => updateApplicationContext({ orderReference2: orderReference2Watcher })}
        label={'ORDER_REFERENCE_2'}
        fieldVariant={FieldVariant.form}
        markAsOptional
      />
    </FormGridContainer>
  );
};
